var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tigan',{attrs:{"topic":_vm.topic,"index":_vm.index}},_vm._l((_vm.topic.childs),function(item,index){return _c('EssayIterm',{key:index,attrs:{"topic":item,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }